import ModalAlerta from "global/component/Genericos/ModalAlerta/ModalAlerta";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { resetOrdenEstudio } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { PortalContext } from "_+_Portal/context/Provider";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import MotivoRechazo from "_+_Portal/_-_Autocheckin/components/genericos/MotivoRechazo/MotivoRechazo";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import {
  setOrden,
  wsGetEstadoOrden,
  wsUpdateUsuarioAltaOrden,
} from "_+_Portal/_-_Autocheckin/context/action/orden";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import { wsGetTurnoByIdQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { proximoPaso } from "../PagesFun";
import { ContainerSubirOrden, Paso2Body } from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import SubirOrdenComponent from "_+_Portal/_-_Autocheckin/components/genericos/SubirOrdenComponent/SubirOrdenComponent";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import CountdownTimer from "_+_Portal/_-_Autocheckin/components/genericos/CountdownTimer/CountdownTimer";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { getLocalStorage } from "global/utils/safeJsonParse";

const SubirOrden = ({ turnoActual, setLoading }) => {
  const { modalDispatch, toasterDispatch, toasterState, modalAlertaState } =
    useContext(GlobalContext);
  const { ordenEstudioState, ordenLaboratorioState, ordenEstudioDispatch } =
    useContext(PortalContext);

  const {
    turnosSeleccionadosState,
    turnosSeleccionadosDispatch,
    ordenDispatch,
    rutaState,
    pasoDispatch,
    rutaDispatch,
    turnosAutoCheckInDispatch,
    puntoControlDispatch,
    usuarioAltaOrdenDispatch,
  } = useContext(AutocheckContext);

  const config = getLocalStorage("config", {});
  let minEstadoOrden = config?.minEstadoOrden;

  const [flgPendiente, setFlgPendiente] = useState(false);
  const [loop, setLoop] = useState(false);
  const [tiempoEspera, setTiempoEspera] = useState("1,5");
  const [lastCheckLabel, setLastCheckLabel] = useState("");
  const [lastCheckTime, setLastCheckTime] = useState("0");
  const [dateLastCheck, setDateLastCheck] = useState(new Date());
  const [loadingOrd, setLoadingOrd] = useState(false);

  const interval = useRef();
  const isComponentMounted = useRef(true);

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];

  const turno = listTurnosSeleccionado[turnoActual];

  //----------------------Funciones----------------------------
  const dismiss = (limpiarOrden) => {
    hideModal()(modalDispatch);
    if (limpiarOrden) {
      setOrden([])(ordenDispatch);
    }
  };
  const nextStepEstadoOrden = (data, isCorrect) => {
    if (isCorrect) {
      //tiempo de espera
      setDateLastCheck(new Date());

      if (data?.turnosAdelante === 0) {
        setLastCheckLabel(
          "Usted es el siguiente en la fila de verificación de orden médica",
        );
      } else {
        setLastCheckLabel(`Personas por delante: ${data.turnosAdelante ?? 0}`);
        setLastCheckTime(data.tiempoEspera ?? "0");
      }
      if (data.estadoOrden === "Validado") {
        setFlgPendiente(false);
        siguientePaso();
      } else if (data.estadoOrden === "Rechazado") {
        setFlgPendiente(false);
        showModal(
          <MotivoRechazo
            idturno={turno?.idturno}
            motivoRechazo={data.motivoRechazo}
            motivoRechazoObservacion={data.motivoRechazoObservacion}
            motivoRechazoRecepcion={data.motivoRechazoRecepcion}
          />,
          "Orden Rechazada",
          dismiss,
          false,
          {},
          "centro",
          true,
        )(modalDispatch);
        stopLoopSubirOrden();
      }
    } else {
      setFlgPendiente(false);
      stopLoopSubirOrden();
    }
  };

  const loopSubirOrden = () => {
    setLoadingOrd(false);

    let msEstadoOrden;
    if (
      minEstadoOrden !== undefined &&
      minEstadoOrden !== null &&
      minEstadoOrden > 0
    ) {
      msEstadoOrden = minEstadoOrden * 10000;
    } else {
      msEstadoOrden = 10000; // 10 segundos por defecto
    }
    setFlgPendiente(true);
    hideModal()(modalDispatch);

    // 1) llamada inicial
    wsGetEstadoOrden(turno?.idturno, true, nextStepEstadoOrden)(ordenDispatch);

    interval.current = setInterval(() => {
      if (isComponentMounted) {
        wsGetEstadoOrden(
          turno?.idturno,
          true,
          nextStepEstadoOrden,
        )(ordenDispatch);
      } else {
        stopLoopSubirOrden();
      }
    }, msEstadoOrden);
    return interval.current;
  };

  const stopLoopSubirOrden = useCallback(() => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  }, []);

  const handleClickVolver = () => {
    stopLoopSubirOrden();
    setPaso("TurnosDelDia")(pasoDispatch);
  };

  const siguientePaso = () => {
    const ruta = rutaState.ruta.data;
    let nextStepTurnoById = (isCorrect, data) => {
      let pathUpdated = [];
      if (isCorrect) {
        // Refrescar el turno en el contexto con la data actualizada del backend.
        // Importante para casos como demanda espontánea donde el operador agrega
        // la práctica recién al controlar la orden — los flags flgSoloPractica /
        // flgSoloConsulta cambian y el siguiente paso (ValidarCobertura) los necesita.
        const turnosActuales =
          turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
        const turnosActualizados = turnosActuales.map((t) =>
          t?.idturno === data?.idturno ? { ...t, ...data } : t,
        );
        setTurnosSeleccionado(turnosActualizados)(turnosSeleccionadosDispatch);

        if (
          data.resumen.validaOnline ||
          data.resumen.validaOnlineEstado === "Pendiente"
        ) {
          pathUpdated.push("ValidarCobertura");
        }
        if (data?.resumen?.monto) {
          pathUpdated.push("AbonarMP");
        }
        pathUpdated.push(ruta.pop());
        setRuta(proximoPaso(pathUpdated, setPaso, pasoDispatch))(rutaDispatch);
      } else {
        enviarPuntoControl();
      }
    };

    setLoading("Actualizando información de turno...");
    wsGetTurnoByIdQr(
      turno?.idturno,
      nextStepTurnoById,
    )(turnosAutoCheckInDispatch);
  };

  const enviarPuntoControl = () => {
    setLoading(true);
    const idTipoPuntoControl = 5;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  //prueba
  const handleEnd = () => {
    //si termino y no se completo la orden aun, se resetea al ultimo estado
    setTiempoEspera(tiempoEspera);
  };

  const formatter = (secs) => {
    if (secs > 60) return "Queda más de un minuto";
    if (secs > 30) return "Menos de un minuto";
    if (secs > 10) return "Se acaba pronto…";
    if (secs > 0) return "¡Ya casi!";
    return "¡Tiempo finalizado!";
  };

  //----------------------Funciones----------------------------

  //----------------------useEffects----------------------------

  useEffect(() => {
    if (
      ordenEstudioState.ordenEstudio.eliminado === "" ||
      ordenLaboratorioState.ordenLaboratorio.eliminado === ""
    ) {
      hideModal()(modalDispatch);
      showToaster(
        {
          texto: "Orden eliminada exitosamente",
          tipo: "success",
        },
        "centroArriba",
      )(toasterDispatch);
      resetOrdenEstudio()(ordenEstudioDispatch);
    }
    //eslint-disable-next-line
  }, [
    ordenEstudioState.ordenEstudio.eliminado,
    ordenLaboratorioState.ordenLaboratorio.eliminado,
  ]);

  useEffect(() => {
    let idInterval;
    if (!loop && turno.tieneFotoOrden) {
      wsUpdateUsuarioAltaOrden(turno.idturno, true)(usuarioAltaOrdenDispatch);
      idInterval = loopSubirOrden();
      setLoop(true);
    }
    return () => {
      clearInterval(idInterval);
    };
  }, []);

  //----------------------useEffects----------------------------

  return (
    <>
      <Loading
        dataLoading={loadingOrd === true}
        descripcion="Cargando..."
        color={"c-white"}
      />
      <LayoutPasos
        volverTo={"/autocheckin/resumen"}
        handleClick={handleClickVolver}
        type={"no-circle"}
        title={"orden médica"}
        children={
          <>
            {toasterState.toaster.show && <ToasterV2 />}
            {modalAlertaState.modalAlerta.show && <ModalAlerta />}
            <CardBlueHeart
              medico={turno?.medico ? turno.medico : turno?.especialidad}
              turnoTitle={turno?.especialidad}
              pasoActual={turnoActual + 1}
              pasoTotal={listTurnosSeleccionado.length}
            />
            <ContainerSubirOrden>
              <PasoBar paso={"SubirOrden"} />
            </ContainerSubirOrden>
            <Paso2Body>
              {!flgPendiente ? (
                <SubirOrdenComponent
                  turno={turno}
                  callback={loopSubirOrden}
                  enviarPuntoControl={enviarPuntoControl}
                  setLoadingOrd={setLoadingOrd}
                />
              ) : (
                <div className="container-texto-promocional">
                  {!!lastCheckLabel ? (
                    <CountdownTimer
                      text={lastCheckLabel}
                      timeString={lastCheckTime}
                      dateLastCheck={dateLastCheck}
                      onComplete={handleEnd}
                      textFormatter={formatter}
                    />
                  ) : (
                    ""
                  )}
                </div>
              )}
            </Paso2Body>
          </>
        }
      ></LayoutPasos>
    </>
  );
};

export default SubirOrden;
